import { LEGALSHIELD_LOGO } from "../../data";

export const PoweredBy = ({ className = "" }) => (
  <div
    data-testid="powered-by-legalshield"
    className={`inline-flex flex-col items-center gap-0.5 rounded-xl bg-white px-3 py-1.5 shadow-[0_4px_20px_rgba(0,0,0,0.35)] ${className}`}
  >
    <span className="font-body text-[8px] md:text-[9px] font-medium uppercase tracking-[0.2em] text-neutral-500 whitespace-nowrap">
      Powered by
    </span>
    <img
      src={LEGALSHIELD_LOGO}
      alt="LegalShield Associate"
      className="h-5 md:h-6 w-auto object-contain"
    />
  </div>
);
